import {
  Farecard,
  FarecardCappingPot,
  FarecardPass,
} from '../services/types/apitypes';
import { UrPassAgency } from '../services/types/urpassapitypes';

const SIMPLE_STORE_CARDS = 'simpleStoreCards';
const SIMPLE_STORE_PASSES = 'simpleStorePasses-';
const SIMPLE_STORE_AUTH = 'simpleStoreAuth';
const SIMPLE_STORE_CAPPING_POTS = 'simpleStoreCappingPots-';
const SIMPLE_STORE_URPASS_TENANTS = 'simpleStoreUrpassTenants';

export const storageSetCards = (cards: Farecard[] | null) => {
  localStorage.setItem(SIMPLE_STORE_CARDS, JSON.stringify(cards));
};

export const storageGetCards = (): Farecard[] | undefined => {
  return getLocalStorage(SIMPLE_STORE_CARDS);
};

export const storageSetPasses = (cardId: string, passes: FarecardPass[]) => {
  localStorage.setItem(SIMPLE_STORE_PASSES + cardId, JSON.stringify(passes));
};

export const storageGetPasses = (
  cardId: string,
): FarecardPass[] | undefined => {
  return getLocalStorage(SIMPLE_STORE_PASSES + cardId);
};

export const storageIsNewAuth = (auth: any): boolean => {
  const stored = localStorage.getItem(SIMPLE_STORE_AUTH);
  const toStore = JSON.stringify(auth);
  return stored !== toStore;
};
export const storageSetAuth = (auth: any) => {
  localStorage.setItem(SIMPLE_STORE_AUTH, JSON.stringify(auth));
};
export const storageGetAuth = () => {
  return getLocalStorage(SIMPLE_STORE_AUTH);
};

export const storageSetCappingPots = (
  pots: FarecardCappingPot[],
  cardId: string,
): void => {
  localStorage.setItem(
    `${SIMPLE_STORE_CAPPING_POTS}${cardId}`,
    JSON.stringify(pots),
  );
};

export const storageGetCappingPots = (
  cardId: string,
): FarecardCappingPot[] | undefined => {
  return getLocalStorage(`${SIMPLE_STORE_CAPPING_POTS}${cardId}`);
};

export const storageSetUrpassTenants = (tenants: UrPassAgency[] | null) => {
  localStorage.setItem(SIMPLE_STORE_URPASS_TENANTS, JSON.stringify(tenants));
};

export const storageGetUrpassTenants = (): UrPassAgency[] | undefined => {
  return getLocalStorage(SIMPLE_STORE_CAPPING_POTS);
};

const getLocalStorage = (key: string): any => {
  const stored = localStorage.getItem(key);
  let parsed = undefined;

  if (stored) {
    try {
      parsed = JSON.parse(stored);
    } catch (error) {
      console.log(`Could not parse ${key}`, error);
    }
  }
  return parsed;
};
